var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11C20.4477 11 20 11.4477 20 12C20 12.5523 20.4477 13 21 13Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.071 17.6569C18.6804 17.2664 18.0473 17.2664 17.6568 17.6569C17.2662 18.0474 17.2662 18.6806 17.6568 19.0711C18.0473 19.4616 18.6804 19.4616 19.071 19.0711C19.4615 18.6806 19.4615 18.0474 19.071 17.6569Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92888 4.92891C5.31941 4.53839 5.95257 4.53839 6.3431 4.92891C6.73362 5.31944 6.73362 5.9526 6.3431 6.34313C5.95257 6.73365 5.31941 6.73365 4.92888 6.34313C4.53836 5.9526 4.53836 5.31944 4.92888 4.92891Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92864 17.6569C5.31916 17.2664 5.95232 17.2664 6.34285 17.6569C6.73337 18.0474 6.73337 18.6806 6.34285 19.0711C5.95232 19.4616 5.31916 19.4616 4.92864 19.0711C4.53811 18.6806 4.53811 18.0474 4.92864 17.6569Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0714 4.92897C18.6808 4.53845 18.0477 4.53845 17.6572 4.92897C17.2666 5.3195 17.2666 5.95266 17.6572 6.34319C18.0477 6.73371 18.6808 6.73371 19.0714 6.34319C19.4619 5.95266 19.4619 5.3195 19.0714 4.92897Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C13.3865 6 14.6632 6.47031 15.6792 7.26011L11.4697 11.4697C11.1768 11.7626 11.1768 12.2374 11.4697 12.5303C11.7626 12.8232 12.2374 12.8232 12.5303 12.5303L16.7399 8.32077C17.5297 9.33678 18 10.6135 18 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDial);
export default __webpack_public_path__ + "static/media/dial.5d859b388064a7ac6f68c3cada8ba3f8.svg";
export { ForwardRef as ReactComponent };